import { parseToInt10 } from 'Common/utilities/parse';

export const getNextPage = (pageNumber) => {
  return parseToInt10(pageNumber) + 1;
};

export const getPreviousPage = (pageNumber) => {
  return parseToInt10(pageNumber) - 1;
};
